import MaterialTable from '@material-table/core'
import { timezoneDate } from 'utils/helpers'
import { fromConstantPropertyToSelectValue } from 'utils/serializers'
import { ExportCsv, ExportPdf } from '@material-table/exporters'

const columns = [
  {
    title: 'Name',
    field: 'name',
    width: '200px',
    sorting: true,
    render: row => (
      <a href={`/proposals/${row.id}`} target="_blank" rel="noreferrer">
        {row.name}
      </a>
    )
  },
  {
    title: 'Sent on',
    field: 'sentDate',
    width: '200px',
    sorting: true,
    render: row => (row.sentDate ? timezoneDate(row.sentDate) : ''),
    exportTransformer: row => (row.sentDate ? timezoneDate(row.sentDate) : null)
  },
  {
    title: 'Status',
    field: 'sentDate',
    width: '200px',
    sorting: false,
    render: row => fromConstantPropertyToSelectValue(row.status, 'ProposalStatus')?.label,
    exportTransformer: row =>
      row.status ? fromConstantPropertyToSelectValue(row.status, 'ProposalStatus').label : null
  }
]

const ProposalsTable = ({ companyProposals, label }) => (
  <MaterialTable
    title=""
    columns={columns}
    data={companyProposals}
    options={{
      actionsColumnIndex: -1,
      sorting: true,
      headerStyle: {
        backgroundColor: '#eee',
        color: '#000',
        position: 'sticky',
        top: 0,
        zIndex: 1,
        fontSize: '14px'
      },
      pageSize: 10,
      pageSizeOptions: [10, 20, 50],
      padding: 'dense',
      exportMenu: [
        {
          label: 'Export PDF',
          exportFunc: (cols, datas) => ExportPdf(cols, datas, label)
        },
        {
          label: 'Export CSV',
          exportFunc: (cols, datas) => ExportCsv(cols, datas, label)
        }
      ]
    }}
    style={{
      boxShadow: 'none',
      fontSize: '13px'
    }}
  />
)

export default ProposalsTable
